export default __webpack_public_path__ + "static/media/data_security_and_information_lifecycle_management.f6072ed0.png";